export default __webpack_public_path__ + "static/media/infoDark.384cf8ee.svg";